import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { User } from '../../models/user';
import { ErrorService } from '../../services/error.service';
import { OrderService } from '../../services/order.service';
import { RouteTrackingService } from '../../services/route-tracking.service';
import { SpinnerService } from '../../services/spinner.service';
import { SubscriptionService } from '../../services/subscription.service';
import { UserService } from '../../services/user.service';
import { ValidatorService } from '../../services/validator.service';
import { EmailShippingLabelData, EmailShippingLabelModalBaseComponent, ShippingLabelContext } from '../email-shipping-label-modal-base/email-shipping-label-modal-base.component';

@Component({
	selector: 'app-email-route-stop-shipping-labels-modal',
	templateUrl: '../email-shipping-label-modal-base/email-shipping-label-modal-base.component.html',
	styleUrls: ['../email-shipping-label-modal-base/email-shipping-label-modal-base.component.css']
})
export class EmailRouteStopShippingLabelsModalComponent extends EmailShippingLabelModalBaseComponent {
	constructor(
		formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any,
		validatorService: ValidatorService,
		spinnerService: SpinnerService,
		errorService: ErrorService,
		orderService: OrderService,
		userService: UserService,
		subscriptionService: SubscriptionService,
		dialogRef: MatDialogRef<EmailRouteStopShippingLabelsModalComponent>,
		private _routeTrackingService: RouteTrackingService
	) {
		super(formBuilder, data, validatorService, spinnerService, errorService, orderService, userService, subscriptionService, dialogRef);
	}

	protected get context(): ShippingLabelContext {
		return 'routeStop';
	}

	protected get titleKey(): string {
		return 'emailShippingLabelView.title';
	}

	protected getDefaultLabelId(user: User): number | null | undefined {
		return user?.inetUser?.routeStopShippingLabelId;
	}

	protected get failureLogLabel(): string {
		return 'emailRouteStopShippingLabels Failed';
	}

	protected performSend(emailData: EmailShippingLabelData, shippingLabelId: number): Observable<any> {
		return this._routeTrackingService.emailRouteStopShippingLabels(
			this.data.routeId,
			this.data.routeStopId,
			emailData,
			shippingLabelId
		);
	}
}
